{
  "metrics": {
    "totalCustomers": "Total de clientes",
    "thisMonth": "este mes",
    "weeklyActive": "Activos semanales",
    "monthlyActive": "Activos mensuales",
    "ofTotalCustomers": "{{percent}}% del total de clientes"
  }
}
